import React, { Component } from 'react';
import { UploadedComment } from './UploadedComment.js';
import PropTypes from 'prop-types';
import {
    Loader,
    NoTopic
} from '../../shared-components';
import { Link } from 'react-router-dom';
import { t } from 'i18next';
import { COMMON_I18N_PREFIX, COMMON_I18N_KEYS } from './constants/i18n/Commoni18nConstants';
import { UPLOADED_COMMENTS_TAB_I18N_PREFIX, UPLOADED_COMMENTS_TAB_I18N_KEYS } from './constants/i18n/UploadedCommentsTabi18nConstants.js';

class UploadedCommentsTab extends Component {
    static propTypes = {
        loadMoreUploadedComments: PropTypes.func.isRequired,
        cookies: PropTypes.object.isRequired,
        updateUploadedCommentRelevance: PropTypes.func.isRequired,
        updateUploadedCommentsIsSarcasmManuallyToggled: PropTypes.func.isRequired,
        topicId: PropTypes.oneOfType([
            PropTypes.array.isRequired,
            PropTypes.object.isRequired
        ])
    };

  constructor(props) {
    super(props);
    this.state = {
        uploadedComments: {
          data: [],
          count: 0
        },
        isInitialLoadOfUploadedCommentsForThisTopic: false,
        isUploadedCommentsLoading: false
    };
  }

  componentDidMount() {
    this._setUploadedCommentsToStateIfNewUploadedComments(this.props);
  }

  componentDidUpdate(prevProps, prevState) {
    this._setUploadedCommentsToStateIfNewUploadedComments(this.props);
  }

  getCommonI18nText(textKey) {
    return t(COMMON_I18N_PREFIX + "." + textKey);
  }

  getUploadedCommentsTabI18nText(textKey) {
    return t(UPLOADED_COMMENTS_TAB_I18N_PREFIX + "." + textKey);
  }

  updateUploadedCommentRelevance = commentId => {
    const { updateUploadedCommentRelevance } = this.props;
    updateUploadedCommentRelevance(commentId);
  };


  _setUploadedCommentsToStateIfNewUploadedComments(nextProps) {
    let updatedState = {};
    if (nextProps.isInitialLoadOfUploadedCommentsForThisTopic != this.state.isInitialLoadOfUploadedCommentsForThisTopic) {
      updatedState.isInitialLoadOfUploadedCommentsForThisTopic = nextProps.isInitialLoadOfUploadedCommentsForThisTopic;
    }
    if (
      Object.keys(nextProps.uploadedComments).length &&
      JSON.stringify(this.state.uploadedComments) !== JSON.stringify(nextProps.uploadedComments)
    ) {
      if (Array.isArray(nextProps.uploadedComments.data)) {
        updatedState.uploadedComments = nextProps.uploadedComments;
      }
    }
    if (nextProps.isUploadedCommentsLoading !== this.state.isUploadedCommentsLoading) {
      updatedState.isUploadedCommentsLoading = nextProps.isUploadedCommentsLoading;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  render() {
    const { topicId } = this.props;
    const { uploadedComments, isUploadedCommentsLoading, isInitialLoadOfUploadedCommentsForThisTopic } = this.state;
    return (
        <div className='feed-comments'>
        {topicId && topicId.length > 0 ? (
          <React.Fragment>
            {isInitialLoadOfUploadedCommentsForThisTopic && <Loader />}
            {!isInitialLoadOfUploadedCommentsForThisTopic && uploadedComments.data.length > 0 &&
              uploadedComments.data.map((comment, _) => (
                <UploadedComment
                  cookies={this.props.cookies.cookies}
                  uploadedComment={comment}
                  key={comment.commentId}
                  updateRelevance={e => this.updateUploadedCommentRelevance(e)}
                  updateUploadedCommentsIsSarcasmManuallyToggled={this.props.updateUploadedCommentsIsSarcasmManuallyToggled}
                />
              ))}
            {!isUploadedCommentsLoading && !isInitialLoadOfUploadedCommentsForThisTopic && !uploadedComments.data.length && (
              <div className="no-feed-comment-data">
                <NoTopic
                  title={this.getCommonI18nText(COMMON_I18N_KEYS.no_articles_title)}
                  message={this.getUploadedCommentsTabI18nText(UPLOADED_COMMENTS_TAB_I18N_KEYS.no_articles_uploaded_comments_tab_message)}
                  icons={['exclamation-circle']}
                >
                  <button className="btn-no-data" onClick={() => this.showContactUs()}>
                  {this.getCommonI18nText(COMMON_I18N_KEYS.contact_us)}
                  </button>
                </NoTopic>
              </div>
            )}
          </React.Fragment>
        ) : (
          <NoTopic
            title={this.getCommonI18nText(COMMON_I18N_KEYS.its_empty_title)}
            message={this.getUploadedCommentsTabI18nText(UPLOADED_COMMENTS_TAB_I18N_KEYS.its_empty_uploaded_comments_tab_message)}
            icons={['comments']}
          >
            <Link to="/dashboard/topics">
              <button className="btn-add-topic">this.getCommonI18nText(COMMON_I18N_KEYS.add_topic)</button>
            </Link>
          </NoTopic>
        )}
        {!isInitialLoadOfUploadedCommentsForThisTopic && uploadedComments.count > 0 && uploadedComments.count > uploadedComments.data.length && (
          <button
            type="button"
            className={`btn btn-loadmore ${isUploadedCommentsLoading ? 'disabled' : ''}`}
            onClick={() => this.props.loadMoreUploadedComments()}
          >
            {isUploadedCommentsLoading ? (
              <React.Fragment>
                <i className="la la-spinner la-spin" /> Loading
              </React.Fragment>
            ) : (
              this.getCommonI18nText(COMMON_I18N_KEYS.load_more)
            )}
          </button>
        )}
      </div>
    );
  }
}

export default UploadedCommentsTab;


// WEBPACK FOOTER //
// ./src/features/home/components/UploadedCommentsTab.js